import { render, staticRenderFns } from "./ModalsComponent.vue?vue&type=template&id=51c73220&scoped=true"
import script from "./ModalsComponent.vue?vue&type=script&lang=js"
export * from "./ModalsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c73220",
  null
  
)

export default component.exports